import { createActionConst } from '../../../utils/action.utils';

const CALENDAR_NAMESPACE = 'CALENDAR';

export const STORE_CALENDAR = createActionConst(CALENDAR_NAMESPACE, 'STORE_CALENDAR');
export const CLEAR_CALENDAR = createActionConst(CALENDAR_NAMESPACE, 'CLEAR_CALENDAR');
